import {Command} from "./Command";
import {AddCommand} from "./AddCommand";
import {SizePropertyChangeCommand} from "./PropertyChangeCommand";
import _ from "lodash";
import {Utils} from "gridstack";


export class DuplicateCommand extends Command {
    constructor(gridContainer, widget, viewMode) {
        super();
        this._container = gridContainer
        this.widget = widget
        this._changes = []
        this._key = `data/props/${viewMode}`
        this._lodashKey = this._key.split("/").join(".")
        this._prepareDuplicateEnvironment()

        this._observer = undefined
    }
    _pushNodes(node, h) {
        let collides = this._container.getGrid().engine.getNodeCollision(node, {pack: true})
        collides = collides.filter(x => {
            if(node.el === undefined) {
                return true
            }
            return node.el !== x.el
        })
        if(collides && collides.length === 1) {
            if (Utils.samePos(node, collides[0])) {
                return
            }
        }
        collides.forEach(x => {
            const vueComponent = x.el.__vue__
            const xNode = {...x, y: x._orig.y + h}
            this._pushNodes(xNode, h)
            this._changes.push(
                this.createSizeChangeCommand(vueComponent, {...x._orig, y: x._orig.y + h})
            )
        })
    }
    _prepareDuplicateEnvironment () {
         // TODO: will come back to this
        const node = this.convertConvrrtNodeToGridStackNode(_.get(this.widget, this._lodashKey, {}))
        this._pushNodes(node, node.h)
        // the add command must come last because
        // if any space is required to fit in the widget, we have to execute those space commands first
        this._changes.push(new AddCommand(this._container, this.widget))
    }

    convertConvrrtNodeToGridStackNode (convrrtNode) {
        return {
            x: convrrtNode.dataX,
            y: convrrtNode.dataY,
            w: convrrtNode. dataWidth,
            h: convrrtNode.dataHeight,
        }
    }
    convertGridStackNodeToConvrrtNode (gridStackNode) {
        return {
            dataX: gridStackNode.x,
            dataY: gridStackNode.y,
            dataWidth: gridStackNode.w,
            dataHeight: gridStackNode.h,
        }
    }

    createSizeChangeCommand (component, gridStackNode) {
        return new SizePropertyChangeCommand(component, this._key, this.convertGridStackNodeToConvrrtNode(gridStackNode))
    }

    get hasChanges () {
        return this._changes.length > 0;
    }

    get $nextTick () {
        return this._container.$nextTick
    }

    subscribeToChangeEvent () {
        this._observer = new MutationObserver((event) => this.changeHandler(event))
        this._observer.observe(this._container.$el, {
            childList: true,
            subtree: true
        })
    }

    unSubscribeToChangeEvent () {
        if (this._observer) {
            this._observer.disconnect()
        }
    }

    changeHandler (event) {
        setTimeout(()=> {
            this._container.enableCommandPush()
            this.unSubscribeToChangeEvent()
        }, 1200)
    }

    async execute() {
        this._container.disableCommandPush()
        for (let i = 0; i < this._changes.length; i++) {
            const command = this._changes[i];
            await command.execute()
        }
        this.subscribeToChangeEvent()
    }

    async unExecute() {
        this._container.disableCommandPush()
        const reversedList = [...this._changes].reverse()
        for (let i = 0; i < reversedList.length; i++) {
            const command = reversedList[i];
            await command.unExecute()
        }
        this.subscribeToChangeEvent()
    }

    addCommand(command) {
        if (command.hasChanges) {
            this._changes.push(command)
        }
    }
}